import script from "./InviteSignup.vue?vue&type=script&setup=true&lang=js"
export * from "./InviteSignup.vue?vue&type=script&setup=true&lang=js"

import "./InviteSignup.vue?vue&type=style&index=0&id=09e070de&scoped=true&lang=css"

import exportComponent from "/builds/p3839/client-suite/proxima_blue2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09e070de"]])

export default __exports__